import type {
  GetUserProfileResponseDTO,
  UpdateUserRequestBodyDTO,
  UploadUserColumnPreferences,
} from 'declarations/dto/user';

import { get, post, put } from './api';

export const getUserProfile: () => Promise<GetUserProfileResponseDTO> = async () => {
  const response = await get<GetUserProfileResponseDTO>(`/users/profile`);

  return response.data;
};

export const putUserProfile: (
  userProfileData: UpdateUserRequestBodyDTO
) => Promise<void> = async userProfileData => {
  const response = await put<void>(`/users/${userProfileData.get('UserId')}`, userProfileData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

  return response.data;
};

export const getUserColumnPreferences: () => Promise<string> = async () => {
  const response = await get<string>(`/users/column-preferences`);

  return response.data;
};

export const uploadUserColumnPreferences: (
  data: UploadUserColumnPreferences
) => Promise<void> = async data => {
  const response = await post<void>(`/users/column-preferences`, data);

  return response.data;
};
